import { render, staticRenderFns } from "./host-common-label.vue?vue&type=template&id=aa436788&scoped=true&"
import script from "./host-common-label.vue?vue&type=script&lang=js&"
export * from "./host-common-label.vue?vue&type=script&lang=js&"
import style0 from "./host-common-label.vue?vue&type=style&index=0&id=aa436788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa436788",
  null
  
)

export default component.exports